import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, COOKIEPOLICY} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import CookiePolicyPage from '@components/Static/CookiePolicy';
import {useDispatch} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';

type CookiePolicyProps = {
  seoConfig: object;
};

const CookiePolicy = ({seoConfig}: CookiePolicyProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, COOKIEPOLICY);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const breadcrumbElements = [
    {
      name: 'Home',
      item: '/',
    },
    {
      name: 'Cookie Policy',
      item: ``,
    },
  ];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          <CookiePolicyPage />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async () => {
    const seoConfig = await loadSEO(COOKIEPOLICY);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: COOKIEPOLICY},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default CookiePolicy;
